import reject from 'lodash/reject'
import * as types from '../actions/types';
import initialState from './initialState';

export default function studentReducer(state = initialState.student, action) {
  switch (action.type) {
    case types.GET_STUDENT_BY_ID_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case types.GET_ALL_STUDENT_LOCKS_SUCCESS:
      return {
        ...state,
        locks: action.payload
      };
    case types.GET_ALL_STUDENT_CONFLICTS_SUCCESS:
      return {
        ...state,
        conflicts: action.payload
      };
    case types.GET_ALL_STUDENT_REQUIREMENTS_SUCCESS:
      return {
        ...state,
        requirements: action.payload
      };
    case types.GET_ALL_STUDENT_OVERRIDES:
      return {
        ...state,
        overrides: action.payload
      };
    case types.GET_ALL_STUDENT_RESTRICTIONS:
      return {
        ...state,
        restrictions: action.payload
      };
    case types.PUT_STUDENTS_COURSES_TO_STATE:
      return {
        ...state,
        courses: action.payload
      };
    case types.GET_ALL_RANK_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferences: action.payload
      };
    case types.GET_LINKS_SUCCESS:
      return {
        ...state,
        links: action.payload
      };
    case types.GET_TOPK_SUCCESS:
      return {
        ...state,
        topks: action.payload
      };
    case types.GET_ALLOCATIONS_SUCCESS:
      return {
        ...state,
        allocations: action.payload
      };
    case types.GET_ALL_STUDENT_COURSES_PREFERENCE_SUCCESS:
      return {
        ...state,
        courses_preference: action.payload
      };
    case types.ASSIGNMENTS_UPDATE_ENTITY:
      return {
        ...state,
        assignments: state.assignments.map(item => item.id === action.payload.id ? {...item, ...action.payload} : item)
      }
    case types.ASSIGNMENTS_DELETE_ENTITY:
      return {
        ...state,
        assignments: reject(state.assignments, { id: action.payload })
      }
    case types.ASSIGNMENTS_DROP:
      return {
        ...state,
        assignments: reject(state.assignments, item => item.id === action.payload)
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/studentReducer.js